import { Component, inject, OnInit } from '@angular/core';
import { LaunchAuthRedirectService } from '../../../common/services/launch-auth-redirect.service';
import { BaseComponent } from '../../../common/components/base.component';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, of, map, finalize, switchMap } from 'rxjs';
import { Message } from '../../../common/enums/message.enum';
import { OrderRoutes } from '../../orders/orders-routes.enum';
import { LicApiCallService, LicLaunchRedirectError } from '../../../common/services/lic-api-call.service';

@Component({
  selector: 'app-lic-auth',
  standalone: false,
  templateUrl: './lic-auth.component.html',
  styleUrl: './lic-auth.component.scss'
})
export class LicAuthComponent extends BaseComponent implements OnInit {

  licApiCallService = inject(LicApiCallService);
  launchAuthRedirectService = inject(LaunchAuthRedirectService);
  pageMessage: string = 'Please wait while we process your launch request.';
  ignoreLaunchContext = false
  ngOnInit() {
    const launchId = this.launchAuthRedirectService.captureFromQueryParams(this.route.snapshot.queryParamMap)
    this.ignoreLaunchContext = this.route.snapshot.queryParamMap.get('ignoreLaunchContext') === 'true'; // ignore in sso callback flow

    this.spinnerService.setLoading(true, 'lic-auth-spinner')
    this.subscriptions.add(this.launchContextObservable(launchId, this.ignoreLaunchContext).pipe(
      switchMap(() => this.handleLICProcess()),
      finalize(() => {
        this.spinnerService.setLoading(false, 'lic-auth-spinner');
      })
    ).subscribe({
      error: (err) => { 
        this.handleError(err);
      }
    }));
  }

  launchContextObservable(launchId, ignoreLaunchContext) {
    if (ignoreLaunchContext) {
      return of({})
    }
    return this.licApiCallService.processLaunchContext(launchId)
  }

  handleLICProcess() {
    const launch$ = this.launchAuthRedirectService.handlePendingLaunchId(this.ignoreLaunchContext)
      .pipe(
        map((handled) => {
          let route: string = OrderRoutes.WELCOME;
          if (handled) {
            route = handled
          }
          return this.router.navigate([route])
        }),
        catchError((error: any) => {
          return this.handleError(error);
        }),
      )

    return launch$;
  }

  handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      console.warn('Launch ID could not be processed after login', error)
      if (error.status === 409 || error.status === 410) {
        this.pageMessage = Message.LaunchInContextConflictProcessErrorMessage;
        this.notificationService.showError(Message.LaunchInContextConflictProcessErrorMessage);
      } else {
        this.pageMessage = Message.LaunchInContextProcessErrorMessage;
        this.notificationService.showError(Message.LaunchInContextProcessErrorMessage)
      }
    } else {
      if (error instanceof LicLaunchRedirectError) {
        this.notificationService.showError(error.message);
      } else {
        console.error('An unexpected error occurred during the LIC process', error);
      }
      this.router.navigate([error.redirect]);
    }
    return of({})
  }
}
